import { useEffect } from "react";
import iconDefs from "./iconSizes.json";

export const PREVIEW_IMAGE_WIDTH = 1200;

export function loadMapImage(map, imageId) {
  return new Promise((resolve, reject) => {
    if (map.hasImage(imageId)) {
      resolve();
      return;
    }

    const mirrored = !!imageId.match(/_mirrored$/);
    const originalImageId = imageId.replace(/_mirrored$/, "");

    if (iconDefs[originalImageId]) {
      map.addImage(
        imageId,
        new ImageData(
          iconDefs[originalImageId].width,
          iconDefs[originalImageId].height
        ),
        { pixelRatio: 3.937007874 }
      );
    }

    const image = new Image();

    image.addEventListener("load", () => {
      let data = image;

      if (mirrored) {
        const canvas = document.createElement("canvas");
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
        const ctx = canvas.getContext("2d");

        ctx.save();
        ctx.scale(-1, 1);
        ctx.drawImage(image, -canvas.width, 0, canvas.width, canvas.height);
        ctx.restore();
        data = ctx.getImageData(0, 0, canvas.width, canvas.height);
      }

      if (iconDefs[originalImageId]) {
        //@ts-ignore
        map.updateImage(imageId, data);
      } else {
        map.addImage(imageId, data, {
          pixelRatio: 3.937007874
        });
      }

      resolve();
    });
    image.addEventListener("error", reject);
    image.src = `${process.env.PUBLIC_URL}/icons/${originalImageId}.svg`;
    image.setAttribute('crossOrigin', '');
  });
}

export const useImageLoader = (mapObj) =>
  useEffect(() => {
    if (!mapObj) return;

    const map = mapObj.getMap();

    function onImageMissing(e) {
      loadMapImage(map, e.id);
    }

    map.on("styleimagemissing", onImageMissing);

    return () => {
      map.off("styleimagemissing", onImageMissing);
    };
  }, [mapObj]);

export function loadImage(src) {
  return new Promise((resolve, reject) => {
    const img = new Image();
    img.src = src;
    img.addEventListener("load", () => {
      resolve(img);
    });
    img.addEventListener("error", reject);
  });
}
